// import { Backdrop, CircularProgress, Tooltip, Typography } from "@mui/material";
// import DataTable from "comps/Tables/DataTable";
// import React, { useEffect, useState } from "react";
// import { useParams } from "react-router-dom";
// import TLinkApi from "services/tlink.api";

// const RecommendationSortConfig = () => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [page, setPage] = useState(1);
//   const [entriesPerPage, setEntriesPerPage] = useState(50);
//   const [data, setData] = useState([]);

//   const fetchData = async () => {
//     setIsLoading(true);
//     try {
//       let data = await TLinkApi.get(
//         `/configurations/supplier-sorting`
//       );
//       setData(data.data);
//       setIsLoading(false);
//     } catch (e) {
//       setIsLoading(false);
//       console.log(e);
//     }
//   };

//   useEffect(() => {
//      fetchData();
//     // eslint-disable-next-line
//   }, []);

// let columns = [

//   {
//     accessor: "supplier_name",
//     Header: "Supplier Name",
//     align: "left",
//     sortable: true,
//     Cell: ({ row }) => {
//       const name = row?.original?.supplier_name;
//       if (!name) return "";
//       const truncated = name.length > 20 ? name.substring(0, 20) + "..." : name;
//       return <Tooltip title={name.length > 20 ? name : ""}><div>{truncated}</div></Tooltip>;
//     },
//   },
//   {
//     accessor: "client_name",
//     Header: "Client Name",
//     align: "left",
//     sortable: true,
//     Cell: ({ row }) => {
//       const name = row?.original?.client_name;
//       if (!name) return "";
//       const truncated = name.length > 20 ? name.substring(0, 20) + "..." : name;
//       return <Tooltip title={name.length > 20 ? name : ""}><div>{truncated}</div></Tooltip>;
//     },
//   },
//   {
//     accessor: "buyer_name",
//     Header: "Buyer Name",
//     align: "left",
//   },
//   {
//     accessor: "language_name",
//     Header: "Language",
//     align: "center",
//     headerAlign: "center",
//   },
//   {
//     accessor: "rule_type_name",
//     Header: "Rule Type",
//     align: "center",
//     headerAlign: "center",
//   },
//   {
//     accessor: "metric_name",
//     Header: "Metric Name",
//     align: "center",
//     headerAlign: "center",
//   },
//   {
//     accessor: "metric_order",
//     Header: "Metric Order",
//     align: "center",
//     headerAlign: "center",
//   },
//   {
//     accessor: "is_desc",
//     Header: "Descending?",
//     align: "center",
//     headerAlign: "center",
//     Cell: ({ row }) => <div>{row.original.is_desc ? "True" : "False"}</div>,
//   },
//   // {
//   //   accessor: "updated_at",
//   //   Header: "Last Updated At",
//   //   align: "center",
//   //   headerAlign: "center",
//   //   Cell: ({ row }) => {
//   //     const date = row?.original?.updated_at;
//   //     return date ? new Date(date).toLocaleString() : "";
//   //   },
//   // },
// ];

//   return (
//     <div>
//       {isLoading ? (
//         <Backdrop
//           sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//           open={isLoading}
//         >
//           <CircularProgress color="inherit" />
//         </Backdrop>
//       ) : (
//         ""
//       )}

//       <DataTable
//         table={{ columns, rows: data }}
//         isSorted
//         entriesPerPage={entriesPerPage}
//         canSearch={false}
//         tablePage={page}
//         setTablePage={setPage}
//         setEntriesPerPage={setEntriesPerPage}
//         totalLength={data.length}
//         pagination={true}
//         enableTopToolbar={true}
//         tableMaxHeight={
//            data.length === 0 ? "calc(100vh - 180px)" : "calc(100vh - 230px)"
//         }
//         tableMinHeight={
//            data.length === 0 ? "calc(100vh - 180px)" : "calc(100vh - 230px)"
//         }
//         renderTopToolbarCustomActions={() => {
//           return (
//             <Typography variant="h6" sx={{ fontWeight: 600 }}>
//               Recommendation Sort Configuration
//             </Typography>
//           );
//         }}
//       />
//     </div>
//   );
// };

// export default RecommendationSortConfig;

import React, { useEffect, useMemo, useState } from "react";
import {
  Backdrop,
  CircularProgress,
  Tooltip,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  TextField,
  Switch,
  FormControl,
  FormLabel,
  Autocomplete,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import MDButton from "components/MDButton";
import DataTable from "comps/Tables/DataTable";
import TLinkApi from "services/tlink.api";
import MRTClientDataTable from "comps/Tables/DataTable/MRTClientDataTable";
import { MRT_ShowHideColumnsButton, MRT_ToggleFiltersButton, MRT_ToggleFullScreenButton } from "material-react-table";

const BASE_ENDPOINT = "/configurations/supplier-sorting";
const LANG_ENDPOINT = "/masters/language";

const oneLine = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};
const isAll = (v) => v === -1 || v === "-1";

export default function RecommendationSortConfig() {
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(50);
  const [data, setData] = useState([]);

  // languages catalog
  const [languages, setLanguages] = useState([]);
  const languageOptions = useMemo(
    () => [{ id: -1, name: "All" }, ...languages],
    [languages]
  );
  const languageMap = useMemo(
    () => Object.fromEntries(languageOptions.map((l) => [l.id, l.name])),
    [languageOptions]
  );

  // modal & form state
  const [modalOpen, setModalOpen] = useState(false);
  const [mode, setMode] = useState("add");
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [editingId, setEditingId] = useState(null);

  const [supplierId, setSupplierId] = useState("");
  const [buyerId, setBuyerId] = useState(""); // allow -1 (All)
  const [clientId, setClientId] = useState("");
  const [languageId, setLanguageId] = useState(null); // -1 for All
  const [ruleType, setRuleType] = useState(1);
  const [metricName, setMetricName] = useState("");
  const [metricOrder, setMetricOrder] = useState("1");
  const [isDesc, setIsDesc] = useState(true);
  const [subBuyerId, setSubBuyerId] = useState("");

  const fetchLanguages = async () => {
    try {
      const res = await TLinkApi.get(LANG_ENDPOINT);
      const list = (res?.data ?? [])
        .map((x) => ({ id: Number(x.id), name: String(x.name) }))
        .sort((a, b) => a.name.localeCompare(b.name));
      setLanguages(list);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const res = await TLinkApi.get(BASE_ENDPOINT);
      const rows = (res?.data ?? []).map((r) => ({
        id: r.id,
        supplier_id: r.supplier_id,
        supplier_name: r.supplier_name,
        client_id: r.client_id,
        client_name: r.client_name,
        buyer_id: r.buyer_id, // may be string "-1"
        buyer_name: r.buyer_name,
        language_id: r.language_id,
        language_name: r.language_name,
        rule_type_name: r.rule_type_name,
        metric_name: r.metric_name,
        metric_order: r.metric_order,
        is_desc: !!r.is_desc,
        updated_at: r.updated_at,
      }));
      setData(rows);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLanguages();
    fetchData();
  }, []);

  const openAdd = () => {
    setMode("add");
    setEditingId(null);
    setSupplierId("");
    setBuyerId(""); // empty or -1
    setClientId("");
    setLanguageId(-1); // default to All
    setRuleType(0);
    setMetricName("");
    setMetricOrder("1");
    setIsDesc(true);
    setErrorMsg("");
    setModalOpen(true);
  };

  const openEdit = (row) => {
    setMode("edit");
    setEditingId(row.id ?? null);
    setSupplierId(String(row.supplier_id ?? ""));
    setBuyerId(row.buyer_id != null ? String(row.buyer_id) : "");
    setClientId(String(row.client_id ?? ""));
    setLanguageId(
      Number.isFinite(Number(row.language_id)) ? Number(row.language_id) : -1
    );
    setRuleType(Number(row.rule_type_name ?? 1));
    setMetricName(String(row.metric_name ?? ""));
    setMetricOrder(String(row.metric_order ?? "1"));
    setIsDesc(Boolean(row.is_desc));
    setErrorMsg("");
    setModalOpen(true);
  };

  const valid =
    supplierId.trim() !== "" &&
    clientId.trim() !== "" &&
    languageId !== null &&
    metricName.trim() !== "" &&
    Number.isFinite(Number(metricOrder));

  const handleSave = async () => {
    if (!valid) {
      setErrorMsg(
        "Please fill all required fields (Supplier, Client, Language, Rule Type, Metric Name, Metric Order)."
      );
      return;
    }
    setSubmitting(true);
    setErrorMsg("");
    try {
      const payload = {
        supplierId: Number(supplierId),
        clientId: Number(clientId),
        buyerId: buyerId.trim() === "" ? null : Number(buyerId),
        subBuyerId: subBuyerId.trim() === "" ? null : Number(subBuyerId),
        languageId: Number(languageId),
        ruleType: Number(ruleType), // must be number
        metricName: metricName.trim(),
        metricOrder: Number(metricOrder),
        isDesc,
      };

      if (mode === "add") {
        await TLinkApi.post(BASE_ENDPOINT, payload);
      } else {
        await TLinkApi.update(`${BASE_ENDPOINT}/${editingId}`, payload);
      }

      setModalOpen(false);
      await fetchData();
    } catch (e) {
      const msg =
        e?.response?.data?.message || e?.message || "Something went wrong";
      setErrorMsg(msg);
    } finally {
      setSubmitting(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        accessor: "supplier_name",
        Header: "Supplier Name",
        align: "left",
        sortable: true,
        Cell: ({ row }) => {
          const name =
            row?.original?.supplier_name ||
            (isAll(row?.original?.supplier_id) ? "All" : "");
          const txt = name || "";
          const trunc = txt.length > 20 ? txt.slice(0, 20) + "..." : txt;
          return (
            <Tooltip title={txt.length > 20 ? txt : ""}>
              <div style={oneLine}>{trunc}</div>
            </Tooltip>
          );
        },
      },
      {
        accessor: "client_name",
        Header: "Client Name",
        align: "left",
        sortable: true,
        Cell: ({ row }) => {
          const name =
            row?.original?.client_name ||
            (isAll(row?.original?.client_id) ? "All" : "");
          const txt = name || "";
          const trunc = txt.length > 20 ? txt.slice(0, 20) + "..." : txt;
          return (
            <Tooltip title={txt.length > 20 ? txt : ""}>
              <div style={oneLine}>{trunc}</div>
            </Tooltip>
          );
        },
      },
      {
        accessor: "buyer_name",
        Header: "Buyer Name",
        align: "left",
        Cell: ({ row }) => {
          const id = row?.original?.buyer_id;
          const name = isAll(id) ? "All" : row?.original?.buyer_name || "";
          const txt = name || "";
          const trunc = txt.length > 20 ? txt.slice(0, 20) + "..." : txt;
          return (
            <Tooltip title={txt.length > 20 ? txt : ""}>
              <div style={oneLine}>{trunc}</div>
            </Tooltip>
          );
        },
      },
      {
        accessor: "language_name",
        Header: "Language",
        align: "center",
        headerAlign: "center",
        Cell: ({ row }) =>
          isAll(row.original.language_id)
            ? "All"
            : row.original.language_name || "",
      },
      {
        accessor: "rule_type_name",
        Header: "Rule Type",
        align: "center",
        headerAlign: "center",
      },
      {
        accessor: "metric_name",
        Header: "Metric Name",
        align: "center",
        headerAlign: "center",
      },
      {
        accessor: "metric_order",
        Header: "Metric Order",
        align: "center",
        headerAlign: "center",
      },
      {
        accessor: "is_desc",
        Header: "Descending",
        align: "center",
        headerAlign: "center",
        Cell: ({ row }) => <div>{row.original.is_desc ? "True" : "False"}</div>,
      },
      {
        accessor: "actions",
        Header: "Actions",
        align: "right",
        headerAlign: "right",
        Cell: ({ row }) => (
          <Stack direction="row" spacing={1} justifyContent="flex-end" pr={1}>
            <IconButton
              size="small"
              onClick={() => openEdit(row.original)}
              sx={{ p: 0.5 }}
            >
              <EditOutlinedIcon fontSize="small" />
            </IconButton>
          </Stack>
        ),
      },
    ],
    []
  );

  const [fullScr, setFullScr] = useState(false);
  const renderToolbarInternalActions = ({ table }) => {
    return (
      <>
        <div style={{ display: "flex", alignItems: "center", gap: "0rem" }}>
          <Button variant="contained" color="info" onClick={openAdd}>
            + New
          </Button>
          <MRT_ShowHideColumnsButton table={table} />
          <MRT_ToggleFiltersButton table={table} />
          <div onClick={() => setFullScr(!fullScr)} >
            <MRT_ToggleFullScreenButton table={table} />
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      {isLoading ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (t) => t.zIndex.drawer + 1 }}
          open={isLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : null}

      {/* <DataTable
        table={{ columns, rows: data }}
        isSorted
        entriesPerPage={entriesPerPage}
        canSearch={false}
        tablePage={page}
        setTablePage={setPage}
        setEntriesPerPage={setEntriesPerPage}
        totalLength={data.length}
        pagination
        enableTopToolbar
        tableMaxHeight={
          data.length === 0 ? "calc(100vh - 220px)" : "calc(100vh - 220px)"
        }
        tableMinHeight={
          data.length === 0 ? "calc(100vh - 220px)" : "calc(100vh - 220px)"
        }
        renderTopToolbarCustomActions={() => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width:
                window.innerWidth > 2500
                  ? "calc(76vw - 580px)"
                  : "calc(76vw - 565px)",
              marginTop: "3px",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Recommendation Sort Configuration
            </Typography>
            <Button variant="contained" color="info" onClick={openAdd}>
              + New
            </Button>
          </Box>
        )}
      /> */}

      <MRTClientDataTable
        table={{ columns, rows: data }}
        isSorted
        canSearch={false}
        enableTopToolbar
        defaultPageSize={entriesPerPage}
        entriesOption={["10", "20", "30", "40", "50"]}
        tableMaxHeight="calc(100vh - 220px)"
        tableMinHeight="calc(100vh - 220px)"
        renderToolbarInternalActions={renderToolbarInternalActions}
        fullScr={fullScr}
        renderTopToolbarCustomActions={() => (
          <Box
            // sx={{
            //   display: "flex",
            //   justifyContent: "space-between",
            //   alignItems: "center",
            //   width:
            //     window.innerWidth > 1600
            //       ? "calc(76vw - 580px)"
            //       : "calc(76vw - 565px)",
            //   mt: "3px",
            // }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Recommendation Sort Configuration
            </Typography>
            {/* <Button variant="contained" color="info" onClick={openAdd}>
              + New
            </Button> */}
          </Box>
        )}
      />

      {/* Add / Edit Modal */}
      <Dialog
        open={modalOpen}
        onClose={() => !submitting && setModalOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>{mode === "add" ? "Add" : "Update"}</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Stack spacing={2}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 0.5, fontSize: 12 }}>
                  Supplier ID
                </FormLabel>
                <TextField
                  size="small"
                  type="number"
                  value={supplierId}
                  onChange={(e) => setSupplierId(e.target.value)}
                  placeholder="-1 for All"
                />
              </FormControl>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 0.5, fontSize: 12 }}>Client ID</FormLabel>
                <TextField
                  size="small"
                  type="number"
                  value={clientId}
                  onChange={(e) => setClientId(e.target.value)}
                  placeholder="-1 for All"
                />
              </FormControl>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 0.5, fontSize: 12 }}>
                  Buyer ID (optional)
                </FormLabel>
                <TextField
                  size="small"
                  type="number"
                  value={buyerId}
                  onChange={(e) => setBuyerId(e.target.value)}
                  placeholder="-1 for All"
                />
              </FormControl>
            </Stack>

            <FormControl fullWidth>
              <FormLabel sx={{ mb: 0.5, fontSize: 12 }}>Language</FormLabel>
              <Autocomplete
                options={languageOptions}
                value={
                  languageOptions.find((l) => l.id === (languageId ?? -1)) ??
                  languageOptions[0]
                }
                onChange={(_, v) => setLanguageId(v?.id ?? -1)}
                getOptionLabel={(opt) => opt?.name ?? ""}
                isOptionEqualToValue={(a, b) => a.id === b.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    placeholder="Pick a language"
                  />
                )}
              />
            </FormControl>

            <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 0.5, fontSize: 12 }}>Rule Type</FormLabel>
                <TextField
                  size="small"
                  type="number"
                  value={ruleType}
                  onChange={(e) => {
                    const val = parseInt(e.target.value, 10);
                    // ✅ Prevent sending values larger than Postgres integer max
                    if (!isNaN(val) && val <= 2147483647) {
                      setRuleType(val);
                    }
                  }}
                  placeholder='e.g. "1"'
                  inputProps={{ min: 1, max: 2147483647 }} // enforce limit in UI
                />
              </FormControl>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 0.5, fontSize: 12 }}>
                  Metric Name
                </FormLabel>
                <TextField
                  size="small"
                  value={metricName}
                  onChange={(e) => setMetricName(e.target.value)}
                  placeholder='e.g. "is_client_priority"'
                />
              </FormControl>
              <FormControl fullWidth>
                <FormLabel sx={{ mb: 0.5, fontSize: 12 }}>
                  Metric Order
                </FormLabel>
                <TextField
                  size="small"
                  type="number"
                  inputProps={{ min: 1, step: 1 }}
                  value={metricOrder}
                  onChange={(e) => setMetricOrder(e.target.value)}
                />
              </FormControl>
            </Stack>

            <FormControl>
              <FormLabel sx={{ mb: 0.5, fontSize: 12 }}>Descending</FormLabel>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Switch
                  checked={isDesc}
                  onChange={(e) => setIsDesc(e.target.checked)}
                />
                <Typography variant="body2">
                  {isDesc ? "True" : "False"}
                </Typography>
              </Stack>
            </FormControl>

            {errorMsg ? (
              <Typography variant="body2" color="error">
                {errorMsg}
              </Typography>
            ) : null}
          </Stack>
        </DialogContent>
        <DialogActions>
          <MDButton
            variant="outlined"
            color="secondary"
            onClick={() => setModalOpen(false)}
            disabled={submitting}
          >
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            color="info"
            onClick={handleSave}
            disabled={submitting || !valid}
          >
            {submitting
              ? mode === "add"
                ? "Saving…"
                : "Updating…"
              : mode === "add"
              ? "Save"
              : "Update"}
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
